"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Text = require("../Text/Text");
var _injectSheet = _interopRequireDefault(require("../style/injectSheet"));
var _excluded = ["classes", "component", "depth"];
/*:: // 

import { type ElementType } from 'react';*/
/*:: import { type InjectSheetProvidedProps } from '../style/ThemeTypes';*/
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Style = function Style() {
  return {
    root: {
      margin: '1rem 0 .5rem'
    }
  };
};
/*:: type Props = InjectSheetProvidedProps & {
  /**
   * Component to be used as the heading
   *-/
  component: ElementType,
  /**
   * Nodes to be placed in the confirmation action container.
   *-/
  depth: number,
  /**
   * Raw markdown used to generate the element
   *-/
  raw: string
};*/
function MarkdownHeading(props /*: Props*/) {
  var classes = props.classes,
    component = props.component,
    depth = props.depth,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  var Component = component;
  switch (depth) {
    case 1:
      Component = _Text.Header1;
      break;
    case 2:
      Component = _Text.Header2;
      break;
    case 3:
      Component = _Text.Header3;
      break;
    case 4:
      Component = _Text.Header4;
      break;
    case 5:
      Component = _Text.Header5;
      break;
    case 6:
      Component = _Text.Header6;
      break;
    default:
      Component = _Text.Header1;
  }
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    className: classes.root
  }, _objectSpread(_objectSpread({}, other), {}, {
    component: "h".concat(depth)
  })));
}
MarkdownHeading.displayName = 'MarkdownHeading';
MarkdownHeading.defaultProps = {
  depth: 1
};
var _default = exports.default = (0, _injectSheet.default)(Style)(MarkdownHeading);
//# sourceMappingURL=Heading.js.map